/**
 * useTeaRooms — active tea rooms for a branch (B.11 ЧАЙНАЯ select). Lazily
 * fetched: pass enabled=false to skip. GET /api/tea-rooms?branch_id= is open
 * to any authenticated user.
 */
import { useEffect, useState } from "react";
import { api } from "../api/client";
import type { ApiList } from "../api/types";

export interface TeaRoom {
  id: string;
  name: string;
  /** Тариф комнаты из настроек (A45: подставляется в расчёт при выборе). */
  price: number;
}

interface RawRoom { id: string; name: string; branch_id?: string; price?: number }

export function useTeaRooms(branchId: string | null, enabled: boolean): { rooms: TeaRoom[]; loading: boolean } {
  const [rooms, setRooms] = useState<TeaRoom[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    setLoading(true);
    const qs = branchId ? `?branch_id=${encodeURIComponent(branchId)}` : "";
    api<ApiList<RawRoom>>(`/api/tea-rooms${qs}`)
      .then((r) => {
        if (!alive) return;
        setRooms((r.results ?? []).map((x) => ({ id: String(x.id), name: x.name, price: Number(x.price) || 0 })));
        setLoading(false);
      })
      .catch(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [branchId, enabled]);

  return { rooms, loading };
}
